var map = {
	"./Broodjesmand.png": 4880,
	"./Sandwhichmand.png": 2603,
	"./banner.jpg": 6358,
	"./galery-image8.jpeg": 6653,
	"./gallery-image1.jpeg": 9732,
	"./gallery-image2.jpeg": 3653,
	"./gallery-image3.jpeg": 9246,
	"./gallery-image4.jpeg": 3015,
	"./gallery-image5.jpeg": 2192,
	"./gallery-image6.jpeg": 3505,
	"./gallery-image7.jpeg": 6106,
	"./gallery-image9.jpg": 963,
	"./menu": 2690,
	"./menu.json": 2690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;